/**
 * Autentiseringstjenester
 */

import { 
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider, 
  signInWithCustomToken,
  signInAnonymously,
  signOut as firebaseSignOut,
  deleteUser as firebaseDeleteUser
} from 'firebase/auth';
import { auth } from './firebase';
import { INITIAL_AUTH_TOKEN } from '../constants/config';

/**
 * Sjekk om vi er på mobil
 */
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Initialiser autentisering
 */
export const initAuth = async () => {
  try {
    if (INITIAL_AUTH_TOKEN) {
      await signInWithCustomToken(auth, INITIAL_AUTH_TOKEN);
    } else {
      await signInAnonymously(auth);
    }
  } catch (error) {
    console.error("Auth error:", error);
    throw error;
  }
};

/**
 * Håndter redirect result (for mobile)
 */
export const handleRedirectResult = async () => {
  try {
    const result = await getRedirectResult(auth);
    if (result?.user) {
      console.log('Redirect result found:', result.user.email);
      return result.user;
    }
    return null;
  } catch (error) {
    console.error("Redirect result error:", error);
    // Ignorer "no redirect result" feil - det er normalt
    if (error.code !== 'auth/no-redirect-result') {
      throw error;
    }
    return null;
  }
};

/**
 * Logg inn med Google
 * Bruker redirect på mobil for å unngå embedded webview-problemer
 */
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  try {
    if (isMobile()) {
      // Bruk redirect på mobil for å unngå "disallowed_useragent" feil
      await signInWithRedirect(auth, provider);
      // Redirect skjer, så vi returnerer null her
      return null;
    } else {
      // Bruk popup på desktop
      const result = await signInWithPopup(auth, provider);
      return result.user;
    }
  } catch (error) {
    console.error("Google sign-in error:", error);
    throw error;
  }
};

/**
 * Logg ut
 */
export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    console.error("Sign out error:", error);
    throw error;
  }
};

/**
 * Slett bruker
 */
export const deleteUser = async () => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Ingen bruker er logget inn');
    }
    
    // Ikke tillat sletting av anonyme brukere (sikkerhet)
    if (user.isAnonymous) {
      throw new Error('Anonyme brukere kan ikke slettes');
    }
    
    await firebaseDeleteUser(user);
  } catch (error) {
    console.error("Delete user error:", error);
    throw error;
  }
};
